import React from 'react';
import { createRoot } from 'react-dom/client';
import EmbedApp from './embed/app';

// Support multiple embeds on the same page - querySelectorAll works with duplicate IDs
const rootElements = document.querySelectorAll('[id="bettoredge"]');

if(rootElements.length > 0){
    rootElements.forEach((rootElement) => {
        const identifier = (rootElement as HTMLElement).dataset.identifier;
        const root = createRoot(rootElement);
        root.render(
            <EmbedApp
                identifier={identifier}
            />
        );
    });
}